function findMissingTagNames(tagCollection = [], tagNames) {
    const existingTagNames = tagCollection.map(tag => tag.data.label);
    return tagNames.filter(tagName => existingTagNames.indexOf(tagName) === -1);
}
export default findMissingTagNames;
//# sourceMappingURL=findMissingTagNames.js.map